import { NavMenu } from 'entities/NavMenu'

export const Navbar = () => {
    return <NavMenu />
}
